import cliente from './cliente'

export default [
    ...cliente,
]